module.exports = __webpack_public_path__ + "img/header-bg-zhTc.97009321.png";